module.exports = __webpack_public_path__ + "img/04.0c43b432.png";